import { AuthContext } from '@dpdgroupuk/cc-dpd-ui';
import { useAuth } from '../../features/Auth/Context';

export function AuthBridge({ children }) {
  const { currentSession, signOut } = useAuth();
  const value = {
    currentSession,
    signOut,
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
